/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import UnsplashAttribution from 'material/embeds/imageapi/imagepane/image/unsplashattribution/unsplash_attribution';
// utils
import takeScreenShot from 'utils/screenshot';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/image/image_styles';
//---- This component is using an HTML2canvas function to crop out the id strip
// on all shutterstock images, all other images or gifs are rendered normally



/* ========== ~~~~~~~~~~ IMAGE PANE : IMAGE ~~~~~~~~~~ ========== */
class Image extends Component {

    constructor(props){
        super(props);
        this.state = {hover: false};
    }

    preview = () => {
        this.setState({hover: true});
        let previewImage = this.props.previewUrl;
        if (previewImage.height) {
            this.props.setPreviewImage(this.props.previewUrl.url);
            // takeScreenShot(props.previewUrl.url,props.previewUrl.width,props.previewUrl.height,props.setPreviewImage,null,null);
            // this takeScreenShot method crops image on hover for preview but causes a delay, without this method preview
            // will contain white strip but when an image is selected the image will be cropped to hide id strip
        } else {
            this.props.setPreviewImage(previewImage);
        }
    }

    submit = () => {
        
        let previewImage = this.props.previewUrl;
        if (previewImage.height) {
            takeScreenShot(this.props.previewUrl.url, this.props.previewUrl.width, this.props.previewUrl.height, this.props.setSelectedImage, this.props.id, this.props.provider);
        } else {
            this.props.setSelectedImage(this.props.provider, this.props.id, previewImage);
        }
    };

    renderType = () => {
        let { url, height, width } = this.props;

        //these inline styles hide the white id strip on the shutterstock photos when they are shown in the image selector;
        if (this.props.height && this.props.width) {
            return (<div className={`imagevisual`} style={{
                overflow: 'hidden', display: 'flex', alignItems: 'center',
                justifyContent: 'center', position: 'relative' }} >

                <div style={{
                    position: 'absolute',
                    overflow: 'hidden',
                    height: `${height}px`,
                    width: `${width}px`,
                }} >
                    <img crossOrigin={'Anonymous'} src={url} alt={''} />
                </div>
                {(this.props.attribution && this.state.hover) ? <UnsplashAttribution adjustedWidth={width} linkEnabled={this.props.activeSelection} attribution={this.props.attribution}/> : null}
            </div>)
        } else {
            return (<div className={`imagevisual`} style={{ backgroundImage: `url(${url})` }} />)
        }
    };

    render(){
        return (
            <div className={`image ${this.props.classes.image}`}
                onClick={() => this.submit()}
                onMouseOver={()=>this.preview()}
                onMouseOut={() => this.props.setPreviewImage(null)} 
                onMouseEnter={()=>this.setState({hover:true})}
                onMouseLeave={()=>this.setState({hover:false})}>
                {this.renderType()}
            </div>)
    }
    
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Image);
